import { SyntheticEvent, useMemo } from "react";

import { RichTreeView } from "@mui/x-tree-view";
import { useLocation } from "react-router-dom";

import { useNavigate } from "hooks/useNavigate";
import { IZone } from "interfaces/zone.interface";
import { makeZoneTree } from "utils/zone.util";

import { useAdministrationStore } from "../administrationStore";

type ZoneMenuProps = {
  zones: IZone[];
};

export const ZoneMenu = ({ zones }: ZoneMenuProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const selectedZoneId = useAdministrationStore(
    (state) => state.selectedZoneId,
  );
  const setSelectedZoneId = useAdministrationStore(
    (state) => state.setSelectedZoneId,
  );

  const expandedZoneIds = useAdministrationStore(
    (state) => state.expandedZoneIds,
  );
  const setExpandedZoneIds = useAdministrationStore(
    (state) => state.setExpandedZoneIds,
  );

  const handleChange = (
    _: SyntheticEvent<Element, Event> | null,
    zoneId: string | null,
  ) => {
    if (zoneId) {
      setSelectedZoneId(zoneId);

      if (!location.pathname.includes("/zone_")) {
        return navigate(`/administration/zones/${zoneId}/devices`);
      }

      if (location.pathname.includes("/dev_")) {
        return navigate(`/administration/zones/${zoneId}/devices`);
      }

      if (location.pathname.includes("/usr_")) {
        return navigate(`/administration/zones/${zoneId}/users`);
      }

      if (location.pathname.includes("/sub_")) {
        return navigate(`/administration/zones/${zoneId}/subjects`);
      }

      const newPath = location.pathname.replace(/\/zone_\w+\//, `/${zoneId}/`);

      return navigate(newPath);
    }
  };

  const items = useMemo(() => makeZoneTree(zones), [zones]);

  return (
    <RichTreeView
      items={items}
      getItemId={(d) => d.id}
      getItemLabel={(d) => d.name}
      expandedItems={
        expandedZoneIds ??
        zones.filter((zone) => zone.hasPartialAccess).map((zone) => zone.id)
      }
      onExpandedItemsChange={(_, ids) => setExpandedZoneIds(ids)}
      selectedItems={selectedZoneId}
      expansionTrigger={"iconContainer"}
      onSelectedItemsChange={handleChange}
      isItemSelectionDisabled={(d) => !d.hasAccess}
      isItemDisabled={(d) => !d.hasPartialAccess}
    />
  );
};
